// Build the Calendly iframe URL with lead prefill params.
// All data comes from server-rendered data-* attributes on the block element —
// no PII is read from the page URL or fetched via a client-side REST call.
const buildCalendlyURL = (
	baseURL: string,
	phoneFieldParam: string,
	email: string,
	fullname: string,
	phone: string
): string => {
	const url = new URL(baseURL);

	if (email) {
		url.searchParams.set('email', email);
	}
	if (fullname) {
		url.searchParams.set('name', fullname);
	}
	if (phone) {
		url.searchParams.set(phoneFieldParam, phone.startsWith('+') ? phone : '+1' + phone);
	}

	url.searchParams.set('embed_domain', window.location.hostname);
	url.searchParams.set('embed_type', 'Inline');

	return url.toString();
};

document.addEventListener('DOMContentLoaded', () => {
	for (const block of document.querySelectorAll('.affiliate-success-calendly-item')) {
		const useDynamicUrl   = block.getAttribute('data-use-dynamic-url') === 'true';
		const baseCalendlyUrl = block.getAttribute('data-base-calendly-url') || '';
		const phoneFieldParam = block.getAttribute('data-phone-field-param') || 'a1';

		if (!useDynamicUrl) {
			continue;
		}

		const iframe = block.querySelector<HTMLIFrameElement>('.calendly-iframe');
		if (!iframe || !baseCalendlyUrl) {
			continue;
		}

		const email    = block.getAttribute('data-email') ?? '';
		const fullname = block.getAttribute('data-fullname') ?? '';
		const phone    = block.getAttribute('data-phone') ?? '';

		// Use the calendar URL pre-computed server-side; fall back to the base URL
		// if none was resolved (e.g. blocked domain or no matching config).
		const calendarUrl = block.getAttribute('data-calendar-url') || baseCalendlyUrl;

		iframe.src = buildCalendlyURL(calendarUrl, phoneFieldParam, email, fullname, phone);
	}
});
